import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { CONTEXTS, setAppContext } from '../store/reducers/appContext.js';

import { APP_SET_IDTOKEN, APP_SET_USER_ID, APP_SET_FCMTOKEN, APP_SET_SLT, APP_SET_LLT } from '../store/reducers/cdvState.js';

const ApplicationContextInitialiser = () => {
	const dispatch = useDispatch();
	const { appUserHome, userId, idToken, appFocusCount, homePageEditMode, fcmToken, slt, llt } = useSelector(state => state.cdvState);

	useEffect(function() {
		let appContext = CONTEXTS.APP_CONTEXT_WEB;
		if(navigator) {


			if(window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true) {
				appContext = CONTEXTS.APP_CONTEXT_PWA;
			}


			if(/TWA/.test(navigator.userAgent) || window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true) {
				appContext = CONTEXTS.APP_CONTEXT_TWA;
			}


			if(window.cordova) {
				appContext = CONTEXTS.APP_CONTEXT_XPA;
				(async function() {
					console.log("Initialising Native App Components");

					const { initialiseFirebase } = await import('../app-lib/Firebase.js');
					let fireBaseResult = await initialiseFirebase();
					console.log("FCM Result: ", JSON.stringify(fireBaseResult));
					if(fireBaseResult.token) {
						dispatch(APP_SET_FCMTOKEN(fireBaseResult));
					}

					const { GoogleAuth } = await import('@codetrix-studio/capacitor-google-auth');
					GoogleAuth.initialize({
					  clientId: '1007974783309-mg9an7g0iadolps8cb0r61n42svn1agu.apps.googleusercontent.com',
					  scopes: ['email'],
					  grantOfflineAccess: false,
					});
					
				})();
			}


		}
		dispatch(setAppContext({ appContext: appContext}));
		console.log("Application showing: ", appContext, " version");
	}, [dispatch]);


	useEffect(function() {
		if(userId && idToken) {
			console.log("User is correctly signed-in on google, handle session creation");
			if(fcmToken) {
				(async function() {
					console.log("Creating user session (& report FCM)");
					const baseUrl = "https://api.floodmapper.co.uk";
					const url = `${baseUrl}/cdv/user/${userId}`;
			        const body = {
			            userId: userId,
			            pushToken: fcmToken,
			            pushTokenType: "fcm",
			            userType: "google",
			            idToken: idToken
			        };

			        try {
			            const response = await fetch(url, {
			                method: 'PUT',
			                headers: {
			                    'Content-Type': 'application/json'
			                },
			                body: JSON.stringify(body)
			            });

			            if (response.ok) {
			                const data = await response.json();
			                console.log("Successfully reported FCM Token");
			                if(data.slt && data.llt) {
			                	dispatch(APP_SET_SLT({ slt: data.slt }));
								dispatch(APP_SET_LLT({ llt: data.llt }));
			                }
			                
			            } else {
			                console.error("Failed to report FCM Token", response.status, response.statusText);
			            }
			        } catch (error) {
			            console.error("Error reporting FCM Token", error);
			        }
				})();
			}
		}
	}, [dispatch, userId, idToken, fcmToken]);

	useEffect(function() {
		(async function() {
			if(!userId || !slt || !llt) {
				return;
			}
			const { Plugins } = await import('@capacitor/core');
	        const { SecureStoragePlugin } = Plugins;
	        try {
	          await SecureStoragePlugin.set({ key: 'SLT', value: slt });
	          await SecureStoragePlugin.set({ key: 'LLT', value: llt });
	          await SecureStoragePlugin.set({ key: 'USERID', value: userId });
	          console.log("Written to NativeStorage (secure) SLT", slt ? '[--redacted:value--]' : '[--is null--]');
	          console.log("Written to NativeStorage (secure) LLT", llt ? '[--redacted:value--]' : '[--is null--]');
	          console.log("Written to NativeStorage (secure) USERID", userId);
	        } catch(error) {
	          console.error("Error writing SLT/LLT: ", error);
	        }
	    })();
	}, [dispatch, userId, slt, llt]);

	return null;
}


export default ApplicationContextInitialiser;